import { Component, OnInit } from '@angular/core';
import { ServiciosService } from 'app/services/servicios.service';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { EstadoTurnosComponent } from 'app/modals/estado-turnos/estado-turnos.component';
import { CelularMovilComponent } from 'app/modals/celular-movil/celular-movil.component';
import { AsignarTiempoMuertoComponent } from 'app/modals/asignar-tiempo-muerto/asignar-tiempo-muerto.component';
import { AgregarMedicoComponent } from '../../../../../modals/agregar-medico/agregar-medico.component';
import { AgregarConductorComponent } from 'app/modals/agregar-conductor/agregar-conductor.component';
import { AgregarEnfermeroComponent } from '../../../../../modals/agregar-enfermero/agregar-enfermero.component';
@Component({
  selector: 'app-equipos',
  templateUrl: './equipos.component.html',
  styleUrls: ['./equipos.component.scss']
})
export class EquiposComponent implements OnInit {

  public tableOpt;/* en sta propiedad se guardan los datos que llegan en getEquipos */

  constructor(private dialog: MatDialog, private serviciosService: ServiciosService) {
    this.tableOpt = [];
   }

  ngOnInit() {
    this.getEquipos();
  }

  actualizar(){
    this.getEquipos();
  }
 /* esta funcion muestra todas las moviles que estan registradas en la tabla equipos */
  getEquipos(){
    this.serviciosService.getEquipos().subscribe(
      (data: any) => {
        this.tableOpt = data.resultado;
      }
    );
    }

  estadoTurnos(datos,i){
    console.log(datos);
    const Dialog = this.dialog.open(EstadoTurnosComponent,{
        data:{
            datos:datos
        }
    })
    Dialog.afterClosed().subscribe(result => {
        if (result=="cerrarTurno") {
            this.tableOpt[i].Medico = "";
            this.tableOpt[i].celmovil = 'Sin registrar';
            this.tableOpt[i].Auxiliar = "";
            this.tableOpt[i].conductor = 'Sin registrar';
        }
      });
    /*  VEHMED, VEHCON, VEHENF, T, CELMOVIL,UltAsigna = 'Base' */
  }

  /* esta funcion abre el modal celular movil el cual permite cambiar el celular que se le asigno a una movil */
  celularmovil(vehcod,celmovil,i){
    console.log(vehcod);
    const dialogRef = this.dialog.open(CelularMovilComponent, {
      data: {
        veh: vehcod,
        cel:celmovil,
        index:i
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      this.tableOpt[i].celmovil = result? result : 'Sin registrar';
    });
  }

  /* esta funcion permite abrir el modal de tiempos muertos  */
  estado(object){
    this.dialog.open(AsignarTiempoMuertoComponent);
  }

  /* esta funcion permite abrir el modal de agregar medico
  el cual nos permite eligir un medico y actualizar la tabla equipos en dicha columna */
  actualizarMedico(movil,i){
    const dialogRef =  this.dialog.open(AgregarMedicoComponent,{
        data:{
            movil: movil
        },
    })
    dialogRef.afterClosed().subscribe(result => {
        this.tableOpt[i].Medico = result? result : this.tableOpt[i].Medico;
      });
  }

  /* esta funcion permite abrir el modal de agregar conductores
  el cual nos permite eligir un conductor y actualizar la tabla equipos en dicha columna */
  actualizarConductor(movil,i){
    const dialogRef =  this.dialog.open(AgregarConductorComponent,{
        data:{
            movil: movil
        }
    })
    dialogRef.afterClosed().subscribe(result => {
        this.tableOpt[i].conductor = result? result : this.tableOpt[i].conductor;
      });
  }

  actualizarAuxliar(movil,i){
    const dialogRef =  this.dialog.open(AgregarEnfermeroComponent,{
        data:{
            movil: movil
        }
    })
    dialogRef.afterClosed().subscribe(result => {
        this.tableOpt[i].Auxiliar = result? result : this.tableOpt[i].Auxiliar;
      });
  }

}
